import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [guideOpen, setGuideOpen] = useState(false);
  const [mobileGuideOpen, setMobileGuideOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const articles = [
    { title: 'Ultimate Guide 2026', path: '/basetao-spreadsheet-ultimate-guide' },
    { title: 'Basetao Review 2026', path: '/basetao-review-2026' },
    { title: 'Is Basetao Legit?', path: '/is-basetao-legit' },
    { title: 'Shipping Cost Guide', path: '/basetao-shipping-cost' },
    { title: 'Warehouse Guide', path: '/basetao-warehouse-guide' },
    { title: 'Coupon & Discounts', path: '/basetao-coupon-discount' },
    { title: 'Best Product Finds', path: '/basetao-product-finds' },
    { title: 'Vs Competitors', path: '/basetao-vs-competitors' },
    { title: 'Beginner Guide', path: '/basetao-beginner-guide' },
    { title: 'Safety Tips', path: '/basetao-safety-tips' },
  ];

  const textColor = scrolled ? 'text-foreground-800' : 'text-white';
  const hoverColor = scrolled ? 'hover:text-primary-500' : 'hover:text-white/80';
  const hamburgerColor = scrolled ? 'text-foreground-800' : 'text-white';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70 shadow-sm'
          : 'bg-gradient-to-b from-black/40 to-transparent'
      }`}
    >
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-16">
          <Link to="/" className="flex items-center gap-2">
            <span className={`font-heading text-xl md:text-2xl font-bold tracking-tight transition-colors duration-300 ${scrolled ? 'text-foreground-900' : 'text-white'}`}>
              Basetao<span className={scrolled ? 'text-primary-500' : 'text-primary-300'}>Sheet</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-6">
            <Link to="/" className={`text-sm font-semibold ${textColor} ${hoverColor} transition-colors whitespace-nowrap cursor-pointer`}>
              Home
            </Link>
            <a href="#categories" className={`text-sm font-medium ${textColor} ${hoverColor} transition-colors whitespace-nowrap`}>Categories</a>
            <a href="#what-is" className={`text-sm font-medium ${textColor} ${hoverColor} transition-colors whitespace-nowrap`}>About</a>
            <a href="#reviews" className={`text-sm font-medium ${textColor} ${hoverColor} transition-colors whitespace-nowrap`}>Reviews</a>

            <div className="relative" onMouseEnter={() => setGuideOpen(true)} onMouseLeave={() => setGuideOpen(false)}>
              <button className={`flex items-center gap-1 text-sm font-medium ${textColor} ${hoverColor} transition-colors whitespace-nowrap cursor-pointer`}>
                Shopping Guide
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`ri-arrow-down-s-line text-sm transition-transform ${guideOpen ? 'rotate-180' : ''}`}></i>
                </div>
              </button>
              {guideOpen && (
                <div className="absolute top-full left-0 mt-2 w-56 bg-background-50 border border-background-200/70 rounded-lg shadow-lg py-2 z-50">
                  {articles.map((a) => (
                    <Link
                      key={a.path}
                      to={a.path}
                      className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {a.title}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-md text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
                scrolled
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-white/20 backdrop-blur-sm text-white border border-white/30 hover:bg-white/30'
              }`}
            >
              Visit Main Site
              <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md ${hamburgerColor} hover:bg-white/10 transition-colors cursor-pointer`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 shadow-lg">
          <div className="px-6 py-4 flex flex-col gap-1 max-h-[70vh] overflow-y-auto">
            <Link to="/" onClick={() => setMobileOpen(false)} className="flex items-center gap-3 text-sm font-semibold text-foreground-800 py-3 border-b border-background-100">
              <div className="w-5 h-5 flex items-center justify-center text-primary-500">
                <i className="ri-home-line"></i>
              </div>
              Home
            </Link>
            <a href="#categories" onClick={() => setMobileOpen(false)} className="flex items-center gap-3 text-sm font-medium text-foreground-700 py-3 border-b border-background-100">
              <div className="w-5 h-5 flex items-center justify-center text-primary-500">
                <i className="ri-grid-line"></i>
              </div>
              Categories
            </a>
            <a href="#what-is" onClick={() => setMobileOpen(false)} className="flex items-center gap-3 text-sm font-medium text-foreground-700 py-3 border-b border-background-100">
              <div className="w-5 h-5 flex items-center justify-center text-primary-500">
                <i className="ri-information-line"></i>
              </div>
              About
            </a>
            <a href="#reviews" onClick={() => setMobileOpen(false)} className="flex items-center gap-3 text-sm font-medium text-foreground-700 py-3 border-b border-background-100">
              <div className="w-5 h-5 flex items-center justify-center text-primary-500">
                <i className="ri-star-line"></i>
              </div>
              Reviews
            </a>

            <button
              onClick={() => setMobileGuideOpen(!mobileGuideOpen)}
              className="flex items-center justify-between w-full text-sm font-medium text-foreground-700 py-3 border-b border-background-100 cursor-pointer"
            >
              <span className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center text-primary-500">
                  <i className="ri-book-open-line"></i>
                </div>
                Shopping Guide
              </span>
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`ri-arrow-down-s-line transition-transform ${mobileGuideOpen ? 'rotate-180' : ''}`}></i>
              </div>
            </button>
            {mobileGuideOpen && (
              <div className="pl-8 flex flex-col gap-1 pb-2">
                {articles.map((a) => (
                  <Link
                    key={a.path}
                    to={a.path}
                    onClick={() => { setMobileOpen(false); setMobileGuideOpen(false); }}
                    className="text-sm text-foreground-600 hover:text-primary-600 py-2 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {a.title}
                  </Link>
                ))}
              </div>
            )}

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              onClick={() => setMobileOpen(false)}
              className="flex items-center justify-center gap-2 mt-2 px-5 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Visit Main Site
              <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}